import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { AlertTriangle, Save, LogOut } from "lucide-react";

// Iter 143: chi esce dal rapportino senza salvare deve accorgersene
export function UnsavedExitDialog({ open, onClose, onSave, onExit, isEdit }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="unsaved-exit-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2 text-red-700">
            <AlertTriangle className="h-5 w-5" /> Rapportino NON salvato
          </DialogTitle>
          <DialogDescription asChild>
            <div className="text-sm text-slate-700 space-y-2 pt-1">
              <p>Hai inserito ore ma <b>non hai premuto Salva</b>.</p>
              {isEdit ? (
                <p>Se esci adesso le modifiche vengono perse.</p>
              ) : (
                <p>Se esci adesso il rapportino <b>non esiste</b>: resta solo come bozza automatica, non conta nelle ore e non va a chi vidima.</p>
              )}
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:flex-row">
          <Button variant="outline" onClick={onExit} className="border-red-300 text-red-700 hover:bg-red-50" data-testid="unsaved-exit-anyway">
            <LogOut className="h-4 w-4 mr-1.5" /> Esci senza salvare
          </Button>
          <Button onClick={onSave} className="bg-[#0044FF] hover:bg-[#0033CC]" data-testid="unsaved-save-now">
            <Save className="h-4 w-4 mr-1.5" /> Salva adesso
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
